import { createGlobalStyle } from 'styled-components';
import { GlobalStylesProps } from './scrollLock.types';

export const GlobalStyles = createGlobalStyle`
  .${(props: GlobalStylesProps) => props.class} {
    overflow: hidden;
    touch-action: none;
  }
`;
